import React, { useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const RichTextEditor = () => {
  const editorRef = useRef(null);
  const [content, setContent] = useState('');

  const handleSave = () => {
    console.log('Editor Content:', content);
    // You can send `content` to API here
  };

  return (
    <div style={{ padding: '20px' }}>
      <Editor
        apiKey="p6cppzwiohaexq97lzt0eghgvowgzhdj8rnw6mn7fyfl37a7"
        onInit={(evt, editor) => (editorRef.current = editor)}
        value={content}
        onEditorChange={(newValue) => setContent(newValue)}
        init={{
          height: 300,
          menubar: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'help',
            'wordcount',
          ],
          toolbar: `
            formatselect |
            bold italic underline forecolor |
            alignleft aligncenter alignright alignjustify |
            bullist numlist |
            link |
            removeformat |
            preview
          `,
          content_style: `
            body {
              font-family: Helvetica, Arial, sans-serif;
              font-size: 14px;
            }
          `,
        }}
      />

      <button
        onClick={handleSave}
        style={{
          marginTop: '10px',
          padding: '8px 16px',
          background: '#1677ff',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        Save Content
      </button>

      <h3 style={{ marginTop: '20px' }}>Preview</h3>
      <div
        style={{
          border: '1px solid #ddd',
          padding: '10px',
          minHeight: '100px',
        }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default RichTextEditor;
